import { Operator } from '@img-arena/consoles-api-streaming'
import type { Column, Filter } from '@/components/table/base'
import { COLUMN_CELL_TYPE } from '@/components/table/base'
import type {
  OperatorFilterParamName,
  OperatorSortAttribute
} from '@/stores/operators/operators.dge.store'

export const DGE_TABLE_COLUMNS: Column<Operator, OperatorSortAttribute>[] = [
  {
    type: COLUMN_CELL_TYPE.TEXT,
    id: 'id',
    label: 'ID',
    sortAttribute: 'id'
  },
  {
    type: COLUMN_CELL_TYPE.TEXT,
    id: 'name',
    label: 'Name',
    sortAttribute: 'name'
  },
  {
    type: COLUMN_CELL_TYPE.NUMBER,
    id: 'mainContactName',
    label: 'Contact Name',
    sortAttribute: 'mainContactName'
  },
  {
    type: COLUMN_CELL_TYPE.TEXT,
    id: 'mainContactEmail',
    label: 'Contact Email',
    sortAttribute: 'mainContactEmail'
  },
  {
    type: COLUMN_CELL_TYPE.TEXT,
    id: 'mainContactTel',
    label: 'Contact Number',
    sortAttribute: 'mainContactTel'
  },
  {
    type: COLUMN_CELL_TYPE.DATE,
    id: 'createdAt',
    label: 'Created At',
    sortAttribute: 'createdAt',
    dateFormat: 'dd-MM-yyyy',
    sx: { whiteSpace: 'nowrap' }
  }
]

export const DGE_TABLE_FILTERS: Filter<Operator, OperatorFilterParamName>[] = [
  {
    type: 'freeTextSearch',
    paramName: 'filter',
    placeholder: 'Search'
  }
]
